"use client";

import { useEffect } from "react";
import { createClient } from "@/lib/supabase/client";

export const runtime = "edge";

export default function LoginPage() {
  useEffect(() => {
    const run = async () => {
      if (typeof window === "undefined") return;
      try {
        const url = new URL(window.location.href);
        const next = url.searchParams.get("next") ?? "/library";
        const supabase = createClient();
        await supabase.auth.signInWithOAuth({
          provider: "google",
          options: {
            redirectTo: `${window.location.origin}/auth/callback?next=${encodeURIComponent(
              next,
            )}`,
          },
        });
      } catch {
        window.location.href = "/";
      }
    };

    void run();
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-paper-bg">
      <div className="text-center">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-paper-muted">
          Redirecting
        </p>
        <p className="mt-3 font-serif text-lg italic text-paper-ink">
          正在跳转到 Google 登录…
        </p>
      </div>
    </div>
  );
}
